<script>
import { mapActions } from 'pinia';

import { useUserStore } from '../../../../store/useUserStore.js';
import * as API from '../../api/followers';
import { startChat } from '../../api/chat';

export default {
  name: 'CpMember',
  components: {
    CpImage: require('../../image').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    CpButton: require('../../button').default,
    CpBox: require('../../box').default,
    CpBoxContent: require('../../box-content').default,
    CpChatButton: require('../../components/ChatButton').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginTop: require('../../directives/margins').marginTop,
    marginRight: require('../../directives/margins').marginRight,
    marginBottom: require('../../directives/margins').marginBottom,
    marginLeft: require('../../directives/margins').marginLeft,
  },
  props: {
    member: { type: Object },
    currentUser: { type: Object },
  },
  data() {
    return {
      userFollow: {
        id: this.member?.id,
        firstname: this.member?.first_name,
        lastname: this.member?.last_name,
        email: this.member?.email,
        state: this.member?.follow_state,
      },
      loadingChat: false,
      loadingFollow: false,
    };
  },
  computed: {
    isFollowing() {
      return this.userFollow.state != 'noFollow';
    },
  },
  methods: {
    follow() {
      this.loadingFollow = true;
      API.follow(this.member?.id)
        .then(async response => {
          this.userFollow.state = response.follow_state;
          this.loadingFollow = false;
          await this.handleChatEnabled(this.member.id);
        })
        .catch(error => {
          this.loadingFollow = false;
          console.warn(error);
        });
    },
    unfollow() {
      this.loadingFollow = true;
      API.unfollow(this.member?.id)
        .then(async response => {
          this.userFollow.state = response.unfollowing.follow_state;
          this.loadingFollow = false;
          await this.handleChatEnabled(this.member.id);
        })
        .catch(error => {
          this.loadingFollow = false;
          console.warn(error);
        });
    },
    handleStartChat() {
      startChat(this.loadingChat, this.member, this.currentUser);
    },
    imageSpan() {
      if (this.$root.isPhone) {
        return 2;
      } else if (this.$root.isMobile) {
        return 1.5;
      } else if (this.$root.isSmallDesktop) {
        return 1.5;
      } else {
        return 1;
      }
    },
    ...mapActions(useUserStore, ['handleChatEnabled']),
  },
};
</script>

<template>
  <cp-box>
    <cp-box-content class="box--outlined user-box">
      <cp-grid>
        <cp-grid-item :span="imageSpan()" class="vertically-centered">
          <a :href="member.permalink">
            <cp-image
              class="user-image"
              :src="member.image"
              circular
              :alt="member.name"
              :width="$root.isMobile ? '30' : '50'"
              :height="$root.isMobile ? '30' : '50'"
            ></cp-image>
          </a>
        </cp-grid-item>
        <cp-grid-item :span="$root.isMobile ? 8 : 5.5" class="vertically-centered">
          <a :href="member.permalink" class="user-link">
            <span v-if="member.name">
              <p v-if="member.name" class="content-5">{{ member.name }}</p>
              <p class="content-3">{{ member.address_city }}</p>
            </span>
            <span v-else>
              <p class="content-5">{{ member.slug }}</p>
            </span>
          </a>
        </cp-grid-item>
        <cp-grid-item :span="$root.isMobile ? 12 : 5" :class="$root.isMobile ?'vertically-centered' : 'buttons-display'">
          <transition name="button-fade" mode="out-in">
            <cp-button v-if="!isFollowing" primary-gradient v-margin="0.2" thin :block="$root.isMobile" @click="follow" :loading="loadingFollow" :disabled="loadingFollow" key="follow"
              >Follow</cp-button
            >
            <cp-button v-else v-margin="0.2" thin :block="$root.isMobile" @click="unfollow" :loading="loadingFollow" :disabled="loadingFollow" key="unfollow">Unfollow</cp-button>
          </transition>
          <CpChatButton :otherUserId="member.id" thin :block="$root.isMobile" :callback="handleStartChat" :loading="loadingChat" :disabled="loadingChat" text="Message" />
        </cp-grid-item>
      </cp-grid>
    </cp-box-content>
  </cp-box>
</template>

<style scoped>
.user-box {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  padding: 20px;
  margin-left: 0;
  transition: all 0.3s;
}

.content-5 {
  font-size: 18px;
  line-height: 21px;
}

.user-box:hover {
  background: #fbfbfb;
  box-shadow: 1px 1px 4px #f8f8f8;
}

.button:active {
  box-shadow: none !important;
}

.text-orange {
  color: var(--hightlight);
}

.vertically-centered {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.user-link {
  color: #000;
  text-decoration: none;
}
.button-fade-enter-active,
.button-fade-leave-active {
  transition: opacity 150ms ease;
}
.button-fade-enter,
.button-fade-leave-to {
  opacity: 0.5;
}
.buttons-display {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .user-image {
    width: 30px;
    height: 30px;
  }
}
</style>
